<template>
	<up-notify ref="notifyRef">
		<template #icon>
			<up-icon name="checkmark-circle-fill" color="#07c160" size="40rpx" v-if="options?.type === 'success'" />
			<up-icon name="close-circle-fill" color="#ff4d4f" size="40rpx" v-if="options?.type === 'error'" />
		</template>
	</up-notify>
</template>

<script setup>
	import {
		ref,
		watch
	} from 'vue'
	import {
		storeToRefs
	} from 'pinia'
	import {
		useNotifyStore
	} from '@/stores/notify'

	const notifyRef = ref()

	const store = useNotifyStore()
	const {
		options,
		timestamp
	} = storeToRefs(store)

	watch(timestamp, () => {
		if (!options.value) return

		notifyRef.value?.show(options.value)
	})
</script>

<style scoped lang="scss">
	::v-deep {
		.u-notify {
			margin: 0 32rpx;
			border-radius: 32rpx;
		}
		
		.u-notify--success {
			background-color: #fff;
				
			.u-notify__warpper__text {
				color: #5ac725 !important;
			}
		}
		
		.u-notify__warpper {
			gap: 10rpx;
		}

		.u-notify--error {
			background-color: #ffeded;

			.u-notify__warpper__text {
				color: #ff4d4f !important;
			}
		}
	}
</style>